import { Pipe, PipeTransform } from '@angular/core';
import { IPosition } from '../interfaces';
import { ApplicantPositionEnum } from '../enums';
@Pipe({
    name: 'HasRoleFilter'
})
export class HasRolePipe implements PipeTransform {

    transform(value: IPosition, args: ApplicantPositionEnum): boolean {
        console.log('HasRolePipe', {value: value, args: args})
        if (value === undefined || args === undefined) {
            return false;
        } else {
            try {
                const role = +value.Order;
                const arg = args[0];
                console.log('HasRolePipe', {value: value, arg: arg, retrun: role >= arg})
                if (role >= arg) {
                    return true;
                } else {
                    return false;
                }
            } catch (err) {
                return false;
            }

        }
    }
}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/pipes/hasRole.pipe.ts